export default __webpack_public_path__ + "images/87c69c4eaf3cfd875097c2566c3b7f7b.webp";